<div class="container-tabs">
  <div class="tabs-btns">
    <button
      *ngFor="let tab of tabs.toArray()"
      (click)="selectTab(tab, true)"
      class="tabs-btn tabs-btn-count-{{tabs.length}}"
      [class.active-tab]="tab.active"
      [textContent]="tab.title"
    >
    </button>
  </div>
</div>
<div class="tabs-content">
  <ng-content></ng-content>
</div>
